/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SinchFaxStatus } from "./SinchFaxStatus";
import type { SinchFaxWebhookFaxLabels } from "./SinchFaxWebhookFaxLabels";

export interface SinchFaxWebhookFax {
  id: string;
  status: SinchFaxStatus;
  labels?: SinchFaxWebhookFaxLabels;
  errorType?: string | null;
  errorCode?: number | null;
  errorMessage?: string | null;
}
